(() => {
  const normal = value => String(value || '').trim().replace(/\s*[x×]\s*/gi, ' × ').replace(/\s+/g, ' ');
  const optionGroup = name => {
    const key = name.toLowerCase();
    if (/fram/.test(key)) return 'framing';
    if (/size|dimension/.test(key)) return 'size';
    if (/colou?r/.test(key)) return 'colour';
    if (/material|metal/.test(key)) return 'material';
    return null;
  };
  const kind = (title, fallback, tags) => {
    const text = title.toLowerCase();
    const matches = [['necklace','Necklaces'],['pendant','Pendants'],['bracelet','Bracelets'],['bangle','Bangles'],['earring','Earrings'],['ring','Rings'],['cushion','Cushions'],['pillow','Cushions'],['rug','Rugs'],['throw','Throws'],['frazada','Throws'],['tote','Totes'],['bag','Bags'],['chair','Chairs'],['frame','Picture frames']];
    if (/limited edition print|art print/i.test(title + ' ' + fallback)) return 'Art prints';
    const match = matches.find(([word]) => text.includes(word));
    if (match) return match[1];
    const tagMatch = matches.find(([word]) => new RegExp('\\b'+word+'s?\\b','i').test(tags));
    return tagMatch ? tagMatch[1] : (/^fashion$/i.test(fallback) ? 'Jewellery' : normal(fallback));
  };
  const material = title => {
    const result = [];
    if (/\bgold\b/i.test(title)) result.push('Gold');
    if (/\bsilver\b/i.test(title)) result.push('Silver');
    return result;
  };
  function setup(root) {
    if (root.dataset.kzReady) return;
    root.dataset.kzReady = 'true';
    let labels;
    try { labels = JSON.parse(root.dataset.filterLabels); } catch { return; }
    const records = Array.from(root.querySelectorAll('[data-kz-card]')).map((node,index) => {
      let options = [], variants = [];
      try { options = JSON.parse(node.dataset.options); variants = JSON.parse(node.dataset.variants); } catch { return null; }
      const title = node.dataset.title;
      return {node,index,title,url:node.querySelector('a').getAttribute('href'),kind:kind(title,node.dataset.kind,node.dataset.tags),created:Number(node.dataset.created),variants:variants.map(variant => {
        const dimensions = {};
        options.forEach((option,i) => { const group = optionGroup(option.name); if(group) { let value=normal(variant.options[i]); if(group==='size') value=({S:'Small',M:'Medium',L:'Large',XL:'Extra large'})[value] || value; dimensions[group]=value; } });
        if (!dimensions.material) { const metals=material(title+' '+variant.options.join(' ')); if(metals.length===1) dimensions.material=metals[0]; }
        return {...variant,dimensions};
      })};
    }).filter(Boolean);
    if (!records.length) return;
    const state = {min:'',max:'',sort:'featured',category:'all'};
    let limit=24;
    const isTiba=root.classList.contains('kz-collection--tiba');
    const categoryMatch=(record)=>{const text=(record.title+' '+record.node.dataset.tags).toLowerCase();if(state.category==='necklaces')return record.kind==='Necklaces';if(state.category==='bracelets')return record.kind==='Bracelets';if(state.category==='men')return /\bmen(?:'s|s)?\b/.test(text);if(state.category==='children')return /child|kids|kid\b/.test(text);if(state.category==='diamonds')return /diamond/.test(text);return true;};
    const controls = {};
    const fields = root.querySelector('[data-kz-filters]');
    const keys = ['kind','material','colour','size','framing'];
    const allValues = {};
    const unique = values => [...new Set(values.filter(Boolean))].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
    keys.forEach(key => {
      const values = unique(key === 'kind' ? records.map(r=>r.kind) : records.flatMap(r=>r.variants.map(v=>v.dimensions[key])));
      if(values.length < 2) return;
      allValues[key] = values;
      const field = document.createElement('label'); field.className='kz-filter-field';
      const caption = document.createElement('span'); caption.textContent=labels[key]; field.append(caption);
      const select = document.createElement('select');select.name=key;select.setAttribute('aria-label',labels[key]);
      const first = document.createElement('option');first.value='';first.textContent=root.dataset.all;select.append(first);
      values.forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;select.append(option);});
      select.addEventListener('change',()=>{state[key]=select.value;update();});field.append(select);fields.append(field);controls[key]=select;
    });
    const moneyLabel = document.createElement('label');moneyLabel.className='kz-filter-field';
    const caption=document.createElement('span');caption.textContent=labels.price+' ('+root.dataset.currency+')';moneyLabel.append(caption);
    const range=document.createElement('span');range.className='kz-price-inputs';
    ['min','max'].forEach(key=>{const input=document.createElement('input');input.type='number';input.min='0';input.step='any';input.placeholder=labels[key];input.setAttribute('aria-label',labels[key]+' '+root.dataset.currency);input.addEventListener('input',()=>{state[key]=input.value;update();});controls[key]=input;range.append(input);});moneyLabel.append(range);fields.append(moneyLabel);
    const availability=document.createElement('label');availability.className='kz-filter-field';
    const availabilityTitle=document.createElement('span');availabilityTitle.textContent=labels.availability;availability.append(availabilityTitle);
    const availableSelect=document.createElement('select');availableSelect.setAttribute('aria-label',labels.availability);
    [['',root.dataset.all],['available',labels.available]].forEach(([value,text])=>{const o=document.createElement('option');o.value=value;o.textContent=text;availableSelect.append(o);});
    availableSelect.addEventListener('change',()=>{state.availability=availableSelect.value;update();});availability.append(availableSelect);fields.append(availability);controls.availability=availableSelect;
    const grid=root.querySelector('[data-kz-grid]');
    function variantsFor(record,skip) {
      return record.variants.filter(v=>{
        if(skip!=='availability' && state.availability && !v.available) return false;
        if(skip!=='price' && state.min!=='' && v.price < Number(state.min)*100) return false;
        if(skip!=='price' && state.max!=='' && v.price > Number(state.max)*100) return false;
        return keys.filter(key=>key!=='kind'&&key!==skip).every(key=>!state[key]||v.dimensions[key]===state[key]);
      });
    }
    function matches(record,skip) {return categoryMatch(record)&&(skip==='kind'||!state.kind||record.kind===state.kind)&&variantsFor(record,skip).length>0;}
    const formatter=new Intl.NumberFormat(root.dataset.locale || 'en',{style:'currency',currency:root.dataset.currency || 'USD',maximumFractionDigits:2});
    function update() {
      const visible=records.filter(record=>matches(record));
      const price=record=>Math.min(...variantsFor(record).map(v=>v.price));
      if(state.sort==='price-asc') visible.sort((a,b)=>price(a)-price(b));
      else if(state.sort==='price-desc') visible.sort((a,b)=>price(b)-price(a));
      else if(state.sort==='newest') visible.sort((a,b)=>b.created-a.created);
      else if(state.sort==='title') visible.sort((a,b)=>a.title.localeCompare(b.title));
      else visible.sort((a,b)=>a.index-b.index);
      const displayed=isTiba?visible.slice(0,limit):visible;
      records.forEach(record=>{record.node.hidden=!displayed.includes(record);});
      visible.forEach(record=>{
        grid.append(record.node);
        const hasOptions=keys.some(key=>key!=='kind'&&state[key]);
        const matching=variantsFor(record);
        const variant=matching.find(v=>v.available)||matching[0];
        const destination=hasOptions&&variant ? record.url+'?variant='+variant.id : record.url;
        record.node.querySelectorAll('a').forEach(link=>link.setAttribute('href',destination));
      });
      if(isTiba){
        const edit=root.querySelector('[data-kz-edit]');edit.hidden=displayed.length<8||state.category!=='all';if(!edit.hidden)displayed[7].node.after(edit);
        root.querySelector('[data-kz-showing]').textContent=root.dataset.showing.replace('[shown]',displayed.length).replace('[total]',visible.length);
        root.querySelector('[data-kz-more]').hidden=displayed.length>=visible.length;
        root.querySelectorAll('[data-kz-category]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.kzCategory===state.category)));
      }
      if(!window.Shopify?.designMode){
        const params=new URLSearchParams();
        Object.entries(state).forEach(([key,value])=>{if(value&&!((key==='sort'&&value==='featured'||key==='category'&&value==='all')))params.set(key,value);});
        const hash=params.size?'#kz='+encodeURIComponent(params.toString()):'';
        history.replaceState(null,'',location.pathname+location.search+hash);
      }
      root.querySelector('[data-kz-count]').textContent=visible.length+' '+(visible.length===1 ? root.dataset.productWord.replace(/s$/, '') : root.dataset.productWord);
      root.querySelector('[data-kz-empty]').hidden=visible.length>0;
      Object.entries(allValues).forEach(([key,values])=>{
        values.forEach(value=>{
          const count=records.filter(record=>{
            if(key==='kind') return record.kind===value&&matches(record,'kind');
            return (!state.kind||record.kind===state.kind)&&variantsFor(record,key).some(v=>v.dimensions[key]===value);
          }).length;
          const option=Array.from(controls[key].options).find(o=>o.value===value);option.textContent=value+' ('+count+')';option.disabled=count===0&&state[key]!==value;
        });
      });
      const active=root.querySelector('[data-kz-active]');active.replaceChildren();
      Object.entries(controls).forEach(([key,control])=>{
        if(!state[key]) return;
        const chip=document.createElement('button');chip.className='kz-chip';
        const value=key==='availability'?labels.available:state[key];
        const text=(labels[key] || key)+': '+value;
        chip.textContent=text+' ×';chip.setAttribute('aria-label',root.dataset.remove+' '+text);
        chip.addEventListener('click',()=>{state[key]='';control.value='';update();});active.append(chip);
      });
      root.querySelector('[data-kz-reset]').hidden=!Object.keys(controls).some(key=>state[key]);
      if(state.min!==''||state.max!==''||state.size||state.framing||state.material||state.colour||state.availability) {
        visible.forEach(record=>{const vs=variantsFor(record);const prices=vs.map(v=>v.price);const min=Math.min(...prices);const max=Math.max(...prices);const target=record.node.querySelector('[data-kz-price]');target.textContent=(min!==max?root.dataset.from+' ':'')+formatter.format(min/100)+' '+root.dataset.currency;});
      } else {
        visible.forEach(record=>{const prices=record.variants.map(v=>v.price);const min=Math.min(...prices);const max=Math.max(...prices);record.node.querySelector('[data-kz-price]').textContent=(min!==max?root.dataset.from+' ':'')+formatter.format(min/100)+' '+root.dataset.currency;});
      }
    }
    root.querySelectorAll('[data-kz-category]').forEach(button=>button.addEventListener('click',()=>{state.category=button.dataset.kzCategory;limit=24;update();}));
    root.querySelector('[data-kz-more]')?.addEventListener('click',()=>{limit+=24;update();});
    root.querySelector('[data-kz-sort]').addEventListener('change',event=>{state.sort=event.target.value;update();});
    root.querySelectorAll('[data-kz-reset]').forEach(button=>button.addEventListener('click',()=>{Object.entries(controls).forEach(([key,control])=>{state[key]='';control.value='';});update();}));
    const details=root.querySelector('details');if(window.matchMedia('(max-width:699px)').matches) details.open=false;
    root.querySelector('[data-kz-toolbar]').hidden=false;
    if(location.hash.startsWith('#kz=')){
      try{
        const saved=new URLSearchParams(decodeURIComponent(location.hash.slice(4)));
        for(const [key,control] of Object.entries(controls)){
          const value=saved.get(key);
          if(value!==null&&(control.tagName!=='SELECT'||Array.from(control.options).some(option=>option.value===value))){state[key]=value;control.value=value;}
        }
        const category=saved.get('category');if(['all','necklaces','bracelets','men','children','diamonds'].includes(category))state.category=category;
        const sort=saved.get('sort');
        const sortControl=root.querySelector('[data-kz-sort]');
        if(sort&&Array.from(sortControl.options).some(option=>option.value===sort)){state.sort=sort;sortControl.value=sort;}
      }catch{}
    }
    update();
  }
  const init=()=>document.querySelectorAll('[data-kz-collection]').forEach(setup);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

